<template>
  <div class="checkmark-container">
    <div class="checkmark"></div>
  </div>
</template>

<script>
export default {
  name: 'Checkmark',

}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.checkmark-container {
  position: relative;
  aspect-ratio: 1;
  height: 100%;
  margin: auto;
}
.checkmark {
  opacity: 0;
  position: absolute;
  transform-origin: left top;
  border-top: 2px solid $kit_green;
  border-right: 2px solid $kit_green;
  transform: scaleX(-1) rotate(135deg);
  top: 50%;
  animation-duration: 1200ms;
  animation-timing-function: ease;
  animation-name: checkmark;
  // animation-iteration-count: infinite;
}
@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 0;
  }
  10% {
    height: 0;
    width: 22.5%;
    opacity: 0.8;
  }
  20% {
    height: 5%;
    width: 45%;
    opacity: 1;
  }
  40% {
    width: 45%;
    height: 90%;
    opacity: 1;
  }
  90% {
    height: 90%;
    width: 45%;
    opacity: 1;
  }
  100% {
    height: 90%;
    width: 45%;
    opacity: 0;
  }
}
</style>
